export interface ICountrySubdivision {
  v: string;
  t: string;
}

const countrySubdivisionsByCountryCode: { [key: string]: ICountrySubdivision[] } = {
  // Ireland counties (North Ireland excluded)
  IE: [
    { v: "IE-CW", t: "Carlow" },
    { v: "IE-CN", t: "Cavan" },
    { v: "IE-CE", t: "Clare" },
    { v: "IE-CO", t: "Cork" },
    { v: "IE-DL", t: "Donegal" },
    { v: "IE-D", t: "Dublin" },
    { v: "IE-G", t: "Galway" },
    { v: "IE-KY", t: "Kerry" },
    { v: "IE-KE", t: "Kildare" },
    { v: "IE-KK", t: "Kilkenny" },
    { v: "IE-LS", t: "Laois" },
    { v: "IS-LM", t: "Leitrim" },
    { v: "IE-LK", t: "Limerick" },
    { v: "IE-LD", t: "Longford" },
    { v: "IE-LH", t: "Louth" },
    { v: "IE-MO", t: "Mayo" },
    { v: "IE-MH", t: "Meath" },
    { v: "IE-MN", t: "Monaghan" },
    { v: "IE-OY", t: "Offaly" },
    { v: "IE-RN", t: "Roscommon" },
    { v: "IE-SO", t: "Sligo" },
    { v: "EI-TA", t: "Tipperary" },
    { v: "IE-WD", t: "Waterford" },
    { v: "IE-WH", t: "Westmeath" },
    { v: "IE-WX", t: "Wexford" },
    { v: "IE-WW", t: "Wicklow" },
  ],
  // US states
  US: [
    { v: "AL", t: "Alabama" },
    { v: "AK", t: "Alaska" },
    { v: "AZ", t: "Arizona" },
    { v: "AR", t: "Arkansas" },
    { v: "AA", t: "Armed Forces America" },
    { v: "AE", t: "Armed Forces Europe" },
    { v: "AP", t: "Armed Forces Pacific" },
    { v: "CA", t: "California" },
    { v: "CO", t: "Colorado" },
    { v: "CT", t: "Connecticut" },
    { v: "DE", t: "Delaware" },
    { v: "DC", t: "District of Columbia" },
    { v: "FL", t: "Florida" },
    { v: "GA", t: "Georgia" },
    { v: "HI", t: "Hawaii" },
    { v: "ID", t: "Idaho" },
    { v: "IL", t: "Illinois" },
    { v: "IN", t: "Indiana" },
    { v: "IA", t: "Iowa" },
    { v: "KS", t: "Kansas" },
    { v: "KY", t: "Kentucky" },
    { v: "LA", t: "Louisiana" },
    { v: "ME", t: "Maine" },
    { v: "MD", t: "Maryland" },
    { v: "MA", t: "Massachusetts" },
    { v: "MI", t: "Michigan" },
    { v: "MN", t: "Minnesota" },
    { v: "MS", t: "Mississippi" },
    { v: "MO", t: "Missouri" },
    { v: "MT", t: "Montana" },
    { v: "NE", t: "Nebraska" },
    { v: "NV", t: "Nevada" },
    { v: "NH", t: "New Hampshire" },
    { v: "NJ", t: "New Jersey" },
    { v: "NM", t: "New Mexico" },
    { v: "NY", t: "New York" },
    { v: "NC", t: "North Carolina" },
    { v: "ND", t: "North Dakota" },
    { v: "OH", t: "Ohio" },
    { v: "OK", t: "Oklahoma" },
    { v: "OR", t: "Oregon" },
    { v: "PA", t: "Pennsylvania" },
    { v: "RI", t: "Rhode Island" },
    { v: "SC", t: "South Carolina" },
    { v: "SD", t: "South Dakota" },
    { v: "TN", t: "Tennessee" },
    { v: "TX", t: "Texas" },
    { v: "UT", t: "Utah" },
    { v: "VT", t: "Vermont" },
    { v: "VA", t: "Virginia" },
    { v: "WA", t: "Washington" },
    { v: "WV", t: "West Virginia" },
    { v: "WI", t: "Wisconsin" },
    { v: "WY", t: "Wyoming" },
  ],
  // Canadian provinces
  CA: [
    { v: "AB", t: "Alberta" },
    { v: "BC", t: "British Columbia" },
    { v: "MB", t: "Manitoba" },
    { v: "NB", t: "New Brunswick" },
    { v: "NL", t: "Newfoundland and Labrador" },
    { v: "NT", t: "Northwest Territories" },
    { v: "NS", t: "Nova Scotia" },
    { v: "NU", t: "Nunavut" },
    { v: "ON", t: "Ontario" },
    { v: "PE", t: "Prince Edward Island" },
    { v: "QC", t: "Quebec" },
    { v: "SK", t: "Saskatchewan" },
    { v: "YT", t: "Yukon" },
  ],
};

export function countrySubdivisionList(countryCode: string): ICountrySubdivision[] | undefined {
  return countrySubdivisionsByCountryCode[countryCode];
}

export function getCountrySubdivision(
  countryCode: string,
  subdivisionCode: string
): string | undefined {
  let result: string | undefined = undefined;
  if (subdivisionCode) {
    const provinceData = (countrySubdivisionList(countryCode) || []).find(
      (item) => item.v === subdivisionCode
    );
    if (provinceData) {
      result = provinceData.t;
    }
  }
  return result;
}
